<template>
  <div class="app-container">
    <el-card shadow="never">
      <app-filter
        :filter-list="table_filter"
        @search="showUploadingBox"
      />
    </el-card>
    <el-card
      shadow="never"
      class="card-style"
    >
      <app-table
        ref="my-table"
        :table-key="table_key"
        :table-props="table_props"
        :tablep="table_params"
        :page-size="15"
        :get-data="getPlanLogs"
      />
    </el-card>
  </div>
</template>
<script>

import PlanLogsResource from '@/api/plan/planLog';
const planLogsResource = new PlanLogsResource();

import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();

export default {
  name: 'RequestResults',
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
  },
  data() {
    return {
      table_key: require('./module/table-key.js')(this),
      table_filter: require('./module/table-filter.js')(this),
      table_params: {
        advertiser: 'gdt',
        page: 1,
        limit: 15,
      },
      // 表格需要属性
      table_props: {
        'stripe': true,
        'height': '550px',
      },
      options: [
        {
          label: '今日头条',
          value: 'jrtt',
        },
        {
          label: '广点通',
          value: 'gdt',
        },
      ],
    };
  },

  /** 生命周期-创建 */
  created() {
    this.getMediasList('gdt');
  },

  methods: {

    // 获取广告主
    getMediasList(advertiser) {
      const params = {
        type: advertiser,
        is_list: true,
      };
      this.table_filter.advertiser_id.options = [];
      return new Promise((resolve, reject) => {
        mediasResource
          .getMediasListApi(params)
          .then((response) => {
            this.table_filter.advertiser_id.options = response.list.map(item => {
              return {
                label: item.advertiser_name,
                value: item.advertiser_id,
              };
            });
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 点击查询
    showUploadingBox(obj){
      // 过滤空参数
      for (const key in obj){
        if (!obj[key] && this.table_params[key]){
          delete obj[key];
          delete this.table_params[key];
        }
      }
      Object.assign(this.table_params, obj);
      this.$nextTick(() => {
        this.$refs['my-table'].seekTable();
      });
    },

    // 查询日志
    async getPlanLogs(parmars) {
      return new Promise((resolve, reject) => {
        planLogsResource
          .getPlanLogs(parmars)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 84px);
  background: #f5f6f7;
  .card-style {
    margin-top: 20px;
  }
}
</style>
